import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, X } from "lucide-react";

// Search bar shared by the Goods Inward (GIN) and Goods Receipt (GRN) pages.
// Lets the user pick Part Number or Supplier Name, type a (partial) value
// and hit Search. `onSearch` receives the query params for GET /gins or
// GET /grns — `{ part_no }` / `{ supplier }`, or `{}` once cleared.
export const SEARCH_FIELDS = {
  part_no: "Part Number",
  supplier: "Supplier Name",
};

export default function GinGrnSearchBar({ onSearch, active, testIdPrefix }) {
  const [field, setField] = useState("part_no");
  const [term, setTerm] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const value = term.trim();
    onSearch(value ? { [field]: value } : {});
  };

  const clear = () => {
    setTerm("");
    onSearch({});
  };

  return (
    <form onSubmit={submit} className="flex flex-wrap items-center gap-2" data-testid={`${testIdPrefix}-search`}>
      <Select value={field} onValueChange={setField}>
        <SelectTrigger className="w-[160px] bg-white" data-testid={`${testIdPrefix}-search-field`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(SEARCH_FIELDS).map(([k, label]) => (
            <SelectItem key={k} value={k}>{label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        placeholder={`Enter ${SEARCH_FIELDS[field]}`}
        className="w-full sm:w-64 bg-white"
        data-testid={`${testIdPrefix}-search-input`}
      />
      <Button type="submit" className="bg-blue-600 hover:bg-blue-700" data-testid={`${testIdPrefix}-search-btn`}>
        <Search className="w-4 h-4 mr-1.5" /> Search
      </Button>
      {active && (
        <Button type="button" variant="outline" onClick={clear} data-testid={`${testIdPrefix}-search-clear`}>
          <X className="w-4 h-4 mr-1.5" /> Clear
        </Button>
      )}
    </form>
  );
}
